import * as React from "react"
const TeamInfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={23}
    height={23}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 64 64"
    {...props}
  >
    <g fill="#fff">
      <path
        d="M24.46 40.44c-.145 5.833 6.847 9.568 11.57 6.34 6.257-3.944 3.454-13.863-4.04-13.86a7.532 7.532 0 0 0-7.53 7.52Z"
        data-original="#000000"
      />
      <path
        d="M43 49.49c-1.164-.97-3.261-1.436-4.68-1.95a9.53 9.53 0 0 1-12.67 0c-.004.004-2.234.754-2.24.75a6.54 6.54 0 0 0-4.95 6.31v2.84A2.57 2.57 0 0 0 21.03 60h21.91a2.557 2.557 0 0 0 2.56-2.41.757.757 0 0 0 .01-.15V54.6A6.434 6.434 0 0 0 43 49.49Zm13.29-1.6-1.51-.5a8.25 8.25 0 0 1-9.26 1.75 8.373 8.373 0 0 1 1.99 5.46v2.84a.757.757 0 0 1-.01.15h10.24A2.264 2.264 0 0 0 60 55.33v-2.29a5.42 5.42 0 0 0-3.71-5.15Z"
        data-original="#000000"
      />
      <path
        d="M45.18 46.65c3.888 3.053 10.112-.012 9.97-5.05a6.266 6.266 0 1 0-9.97 5.05Zm-33.76 0c3.884 3.053 10.102-.017 9.96-5.05a6.271 6.271 0 0 0-6.26-6.27c-6.034-.025-8.543 7.861-3.7 11.32Zm-2.2.74-1.51.5A5.42 5.42 0 0 0 4 53.04v2.29a2.264 2.264 0 0 0 2.26 2.26h10.21c-.116-2.917-.123-6.172 1.97-8.43a8.262 8.262 0 0 1-9.22-1.77ZM28.5 26.02l2.69 3.58a1.003 1.003 0 0 0 1.6 0l2.68-3.58C47.555 21.847 44.811 4.244 31.99 4c-12.834.245-15.577 17.843-3.49 22.02Zm3.25-18.11a1.48 1.48 0 0 1 0 2.96 1.48 1.48 0 0 1 0-2.96Zm-1.2 6.22a1 1 0 0 1 0-2c.866.047 2.394-.32 2.44 1v6.78c.703-.082 1.424.195 1.44 1a1.003 1.003 0 0 1-1 1h-2.88a.997.997 0 0 1-1-1c.016-.81.728-1.08 1.44-1v-5.78Z"
        data-original="#000000"
      />
    </g>
  </svg>
)
export default TeamInfoIcon
